export function makeBookingDetails(chosenProduct, chosenSlot, accessories, about, totalPrice, bookingId, operatorId, coupon) {
    return {
        _type: 'booking.details',
        accessoryIds: accessories.map(accessory => accessory.id),
        lastName: about.lastName,
        chosenSlotLabel: chosenSlot.label,
        firstName: about.firstName,
        yearAndColourOfCar: about.yearAndColourOfCar,
        postcode: about.postcode,
        totalPrice: totalPrice.toString(),
        makeOfCar: about.makeOfCar,
        chosenSlotId: chosenSlot.id,
        firstLineOfAddress: about.firstLineOfAddress,
        chosenDate: chosenProduct.id,
        phone: about.phone,
        modelOfCar: about.modelOfCar,
        email: about.email,
        chosenProductId: chosenProduct.productId,
        bookingId,
        operatorId,
        howDidYouHearAboutUs: about.howDidYouHearAboutUs,
        notes: about.notes,
        couponCode: coupon ? coupon.couponCode : null,
    };
}
